module.exports = __webpack_public_path__ + "static/media/dotdotdot.2f252ea1.gif";